// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2WZiK","row":"styles_row__3Ppnz","noUnderline":"styles_noUnderline__2uvck","infoText":"styles_infoText__jujpE"};